import React, { useEffect, useRef } from 'react';
import './marquee-line.scss';

const MarqueeLine = ({ text = "LIMITED EDITION 💎" }) => {
    const svgRef = useRef(null);
    const animationRef = useRef(null);

    useEffect(() => {
        const svg = svgRef.current;
        if (!svg) return;

        const tspans = svg.querySelectorAll('.Marquee-svg-text');

        const animate = () => {
            tspans.forEach((tspan) => {
                const currentX = parseFloat(tspan.getAttribute('x')) || 0;
                const newX = currentX - 1;
                tspan.setAttribute('x', newX);

                if (newX < -2200) {
                    tspan.setAttribute('x', 4400);
                }
            });

            animationRef.current = requestAnimationFrame(animate);
        };

        animate();

        return () => {
            if (animationRef.current) {
                cancelAnimationFrame(animationRef.current);
            }
        };
    }, []); 

    return (
        <h1 className='marquee-text'>
            <svg ref={svgRef} width="100%" height="240">
                <path
                    fill="none"
                    stroke="transparent"
                    strokeWidth="0"
                    d="M-550,59.580000000000005  L-550,59.580000000000005 S-183.15,209.58 0,209.58 S366.85,59.580000000000005 550,59.580000000000005 S916.85,209.58 1100,209.58 S1466.85,59.580000000000005 1650,59.580000000000005 S2016.85,209.58 2200,209.58 S2566.85,59.580000000000005 2750,59.580000000000005"
                    strokeDasharray="700 32"
                    id="textPath"
                    strokeDashoffset="0"
                />
                <text>
                    <textPath className="Marquee-svg-text" href="#textPath">
                        <tspan className="Marquee-svg-text" x="0">{text}</tspan>
                        <tspan className="Marquee-svg-text" x="2200">{text}</tspan>
                        <tspan className="Marquee-svg-text" x="4400">{text}</tspan>
                    </textPath>
                </text>
            </svg>
        </h1>
    );
};

export default MarqueeLine;